import { render, staticRenderFns } from "./Speech.vue?vue&type=template&id=b7cb871a&scoped=true&"
import script from "./Speech.vue?vue&type=script&lang=js&"
export * from "./Speech.vue?vue&type=script&lang=js&"
import style0 from "./Speech.vue?vue&type=style&index=0&id=b7cb871a&lang=scss&scoped=true&"
import style1 from "./Speech.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cb871a",
  null
  
)

export default component.exports